export const SOX_MARKETING_REP_GROUP_EMAIL = "MktgRepSOXPriceAudit@paalp.com";